import { toast } from 'react-toastify';

export const DEFAULT_TYPE = 'DEFAULT_TYPE';
export const INFO_TYPE = 'INFO_TYPE';
export const ERROR_TYPE = 'ERROR_TYPE';
export const SUCCESS_TYPE = 'SUCCESS_TYPE';
export const WARNING_TYPE = 'WARNING_TYPE';

const toastTypeSelector = (type = DEFAULT_TYPE) => {
  switch (type) {
    case INFO_TYPE:
      return toast.info;
    case ERROR_TYPE:
      return toast.error;
    case SUCCESS_TYPE:
      return toast.success;
    case WARNING_TYPE:
      return toast.warning;
    default:
      return toast;
  }
};

export const DEFAULT = 'DEFAULT';
export const BOT_CREATION = 'BOT_CREATION';
export const BOT_UPDATE = 'BOT_UPDATE';
export const BOT_DELETION = 'BOT_DELETION';
export const BOT_ERROR_GROUPS_GETTER = 'BOT_ERROR_GROUPS_GETTER';
export const BOT_ERRORS_DETAILS_GETTER = 'BOT_ERRORS_DETAILS_GETTER';
export const BOT_SPEC_UPDATE = 'BOT_SPEC_UPDATE';
export const FUNCTION_CREATION = 'FUNCTION_CREATION';
export const FUNCTION_UPDATE = 'FUNCTION_UPDATE';
export const FUNCTION_DELETION = 'FUNCTION_DELETION';
export const MESSAGE_CREATION = 'MESSAGE_CREATION';
export const MESSAGE_UPDATE = 'MESSAGE_UPDATE';
export const MESSAGE_DELETION = 'MESSAGE_DELETION';
export const STORAGE_UPDATE = 'STORAGE_UPDATE';
export const VARIABLE_CREATION = 'VARIABLE_CREATION';
export const VARIABLE_UPDATE = 'VARIABLE_UPDATE';
export const VARIABLE_DELETION = 'VARIABLE_DELETION';
export const INTEGRATION_UPDATE = 'INTEGRATION_UPDATE';
export const TEMPLATE_CREATION = 'TEMPLATE_CREATION';
export const TEMPLATE_UPDATE = 'TEMPLATE_UPDATE';
export const BOT_PUBLISHED = 'BOT_PUBLISHED';
export const BOT_PUBLISHED_UPDATE = 'BOT_PUBLISHED_UPDATE';
export const GLOBAL_VARIABLES_GETTER = 'GLOBAL_VARIABLES_GETTER';
export const GLOBAL_VARIABLE_CREATION = 'GLOBAL_VARIABLE_CREATION';
export const GLOBAL_VARIABLE_UPDATE = 'GLOBAL_VARIABLE_UPDATE';
export const GLOBAL_VARIABLE_DELETION = 'GLOBAL_VARIABLE_DELETION';
export const GLOBAL_FUNCTIONS_GETTER = 'GLOBAL_FUNCTIONS_GETTER';
export const GLOBAL_FUNCTION_CREATION = 'GLOBAL_FUNCTION_CREATION';
export const GLOBAL_FUNCTION_UPDATE = 'GLOBAL_FUNCTION_UPDATE';
export const GLOBAL_FUNCTION_DELETION = 'GLOBAL_FUNCTION_DELETION';

const messages = {
  DEFAULT: {
    ERROR_TYPE: 'Something went wrong, please try again',
    SUCCESS_TYPE: 'Done',
  },
  BOT_CREATION: {
    ERROR_TYPE: 'Something went wrong creating bot',
    SUCCESS_TYPE: 'Bot was successfully created',
  },
  BOT_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating bot',
    SUCCESS_TYPE: 'Bot was successfully updated',
  },
  BOT_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting bot',
    SUCCESS_TYPE: 'Bot was successfully deleted',
  },
  BOT_ERROR_GROUPS_GETTER: {
    ERROR_TYPE: 'Something went wrong getting the error groups',
    SUCCESS_TYPE: 'Error groups obtained',
  },
  BOT_ERRORS_DETAILS_GETTER: {
    ERROR_TYPE: 'Something went wrong getting the errors details',
    SUCCESS_TYPE: 'Errors details obtained',
  },
  BOT_SPEC_UPDATE: {
    ERROR_TYPE: 'Something went wrong saving your changes, please try again',
    SUCCESS_TYPE: 'SpecJson was successfully updated',
  },
  FUNCTION_CREATION: {
    ERROR_TYPE: 'Something went wrong creating function',
    SUCCESS_TYPE: 'Function was successfully created',
  },
  FUNCTION_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating function',
    SUCCESS_TYPE: 'Function was successfully updated',
  },
  FUNCTION_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting function',
    SUCCESS_TYPE: 'Function was successfully deleted',
  },
  MESSAGE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating message',
    SUCCESS_TYPE: 'Message was successfully created',
  },
  MESSAGE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating message',
    SUCCESS_TYPE: 'Message was successfully updated',
  },
  MESSAGE_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting message',
    SUCCESS_TYPE: 'Message was successfully deleted',
  },
  STORAGE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating storage',
    SUCCESS_TYPE: 'Storage was successfully updated',
  },
  VARIABLE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating variable',
    SUCCESS_TYPE: 'Variable was successfully created',
  },
  VARIABLE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating variable',
    SUCCESS_TYPE: 'Variable was successfully updated',
  },
  VARIABLE_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting variable',
    SUCCESS_TYPE: 'Variable was successfully deleted',
  },
  INTEGRATION_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the integration',
    SUCCESS_TYPE: 'Integration was successfully updated',
  },
  TEMPLATE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating the template',
    SUCCESS_TYPE: 'Template was successfully created',
  },
  TEMPLATE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the template',
    SUCCESS_TYPE: 'Template was successfully updated',
  },
  BOT_PUBLISHED: {
    ERROR_TYPE: 'Something went wrong publishing the bot',
    SUCCESS_TYPE: 'Bot was successfully published',
  },
  BOT_PUBLISHED_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the published bot',
    SUCCESS_TYPE: 'Published bot was successfully updated',
  },
  GLOBAL_VARIABLES_GETTER: {
    ERROR_TYPE: 'Something went wrong getting global variables',
    SUCCESS_TYPE: 'Global variables obtained',
  },
  GLOBAL_VARIABLE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating global variable',
    SUCCESS_TYPE: 'Global variable was successfully created',
  },
  GLOBAL_VARIABLE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating global variable',
    SUCCESS_TYPE: 'Global variable was successfully updated',
  },
  GLOBAL_VARIABLE_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting global variable',
    SUCCESS_TYPE: 'Global variable was successfully deleted',
  },
  GLOBAL_FUNCTIONS_GETTER: {
    ERROR_TYPE: 'Something went wrong getting global functions',
    SUCCESS_TYPE: 'Global functions obtained',
  },
  GLOBAL_FUNCTION_CREATION: {
    ERROR_TYPE: 'Something went wrong creating global function',
    SUCCESS_TYPE: 'Global function was successfully created',
  },
  GLOBAL_FUNCTION_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating global function',
    SUCCESS_TYPE: 'Global function was successfully updated',
  },
  GLOBAL_FUNCTION_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting global function',
    SUCCESS_TYPE: 'Global function was successfully deleted',
  },
};

/**
 * Muestra un toast con el mensaje de `actionId` para el `type` (éxito, error…).
 * @param {object} options
 * @param {string} [options.elementName] Se agrega al final del mensaje.
 * @param {string} [options.actionId]
 * @param {import('react-toastify').ToastPosition} [options.position]
 * @param {(key: string) => string} options.texts
 * @param {string} options.type
 */
const toastDispacher = ({
  elementName,
  actionId = DEFAULT,
  // react-toastify v11 eliminó el enum `toast.POSITION`; ahora la posición es un
  // string literal ('bottom-left' equivale al antiguo toast.POSITION.BOTTOM_LEFT).
  position = 'bottom-left',
  texts,
  type,
}) => {
  const toastDispatch = toastTypeSelector(type);
  let message = texts(messages[actionId][type]);
  if (elementName) {
    message += `: ${elementName}`;
  }
  message += '.';
  toastDispatch(message, { position });
};

export default toastDispacher;
